import styled from "styled-components";
import theme, { brickTexture } from "../../styles/theme";

// The "brick" pill. Topics and subtopics both render as these: small, dense,
// wrap-packed tiles that stay scannable when the window is only a few hundred
// pixels wide. Do not grow these into cards — see PillGrid.

export const PillGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.space.sm};
  align-content: flex-start;
  justify-content: center;
  padding: ${theme.space.md} ${theme.space.md} 0;
`;

export const Pill = styled.button`
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.xs};

  min-height: 26px;
  /* Cannot outgrow the row: in the narrow teleprompter window a long question
     wraps onto extra lines inside the pill instead of overflowing sideways. */
  max-width: 100%;
  padding: ${theme.space.xs} ${theme.space.md};
  border: none;
  border-radius: ${theme.radius.sm};
  cursor: pointer;

  background-color: ${theme.color.brick};
  ${brickTexture}
  box-shadow: ${theme.shadow.brick};

  color: ${theme.color.text};
  font-family: inherit;
  font-size: ${theme.font.md};
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  /* Topic pills render as router links; suppress the anchor underline. */
  text-decoration: none;

  transition: transform 0.15s, box-shadow 0.15s, background-color 0.15s;

  &:hover {
    background-color: ${theme.color.brickHover};
    box-shadow: ${theme.shadow.brickHover};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.focus};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:hover {
      transform: none;
    }
  }
`;

// Small remove affordance in the pill's corner. Previously this was
// opacity:0 until hover, which made it unreachable by keyboard; it now also
// appears on keyboard focus.
export const PillRemove = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${theme.color.danger};
  color: #ffffff;
  font-size: 11px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s;

  ${Pill}:hover &,
  ${Pill}:focus-visible &,
  &:focus-visible {
    opacity: 1;
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.focus};
    outline-offset: 1px;
  }

  &:hover {
    background: #b91c1c;
  }
`;

export const EmptyState = styled.p`
  margin: ${theme.space.xl} auto;
  max-width: 32ch;
  text-align: center;
  color: ${theme.color.textFaint};
  font-size: ${theme.font.md};
  line-height: 1.5;
`;
